<template>
  <div class="page-default page-dashcam">
    <div class="row m-0 page-section bg-dashboard-dark-2">
      <div
        class="col col-md-4 col-lg-3 section-left"
        :class="{ show: showSidebar }"
      >
        <div class="case-container bg-dashboard-dark-1 border-outline-dark">
          <div class="case-header text-capitalize text-light">
            <div class="d-flex justify-content-center align-items-center">
              Page
              <input
                class="form-control form-control-default form-control-sm text-center mx-1 px-0 bg-dark-input text-white"
                style="width: 28px; font-size: 90%"
                v-model="inputPage"
                type="number"
                :disabled="totalPage <= 1"
                @keydown.enter="changePage(inputPage)"
                @blur="changePage(inputPage)"
                data-toggle="tooltip"
                data-placement="bottom"
                title="Enter number of page"
                @mouseover="helper.showTooltip"
                @mouseleave="helper.hideTooltip"
              />
              <p class="mb-0 text-nowrap">/ {{ totalPage || 1 }}</p>
              <div class="btn-group ml-2">
                <button
                  class="btn btn-dark btn-sm border border-outline-dark-all"
                  title="Previous page"
                  :disabled="currentPage <= 1"
                  @click="changePage(currentPage - 1)"
                  data-toggle="tooltip"
                  data-placement="bottom"
                  @mouseover="helper.showTooltip"
                  @mouseleave="helper.hideTooltip"
                >
                  &#8249;
                </button>
                <button
                  class="btn btn-dark btn-sm border border-outline-dark-all"
                  title="Next page"
                  :disabled="currentPage >= totalPage"
                  @click="changePage(currentPage + 1)"
                  data-toggle="tooltip"
                  data-placement="bottom"
                  @mouseover="helper.showTooltip"
                  @mouseleave="helper.hideTooltip"
                >
                  &#8250;
                </button>
              </div>
            </div>
            <div class="d-flex align-items-center">
              <div
                class="case-header-icon clickable ml-4 d-block d-md-none"
                @click="toggleSidebar()"
                data-toggle="tooltip"
                data-placement="bottom"
                title="Click to open sidebar"
                @mouseover="helper.showTooltip"
                @mouseleave="helper.hideTooltip"
              >
                <font-awesome-icon :icon="['fas', 'times']" />
              </div>
            </div>
          </div>
          <!-- dashcam filter -->
          <div class="case-filter">
            <div
              class="row mx-0"
              :style="{
                transition: 'all 0.3s',
                height: hideFilter ? '0' : 'calc(3px + (87px*3))',
                overflow: hideFilter ? 'hidden' : 'unset',
              }"
            >
              <div
                class="col-6 px-0 border-right border-bottom border-outline-dark"
              >
                <div class="dropdown h-100">
                  <button
                    class="btn btn-sm btn-block no-focus position-relative rounded-0 py-0 px-2 d-flex justify-content-between align-items-center overflow-hidden dropdown-toggle text-light h-100"
                    type="button"
                    id="dropdownDistrictButton"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    data-placement="bottom"
                    title="Select district"
                    @mouseover="helper.showTooltip"
                    @mouseleave="helper.hideTooltip"
                  >
                    <div
                      class="d-flex justify-content-start align-items-center w-100 py-2"
                    >
                      <div class="mr-2">
                        <font-awesome-icon
                          :icon="['fas', 'filter']"
                          :class="
                            currentDistrict ? 'text-primary' : 'text-light'
                          "
                        />
                        <font-awesome-icon
                          :icon="['fas', 'check-circle']"
                          class="text-success bg-dark rounded-circle"
                          style="
                            font-size: 0.85em;
                            position: absolute;
                            top: 1.55em;
                            right: 0.45em;
                          "
                          v-if="currentDistrict"
                        />
                      </div>
                      <div
                        class="text-left overflow-hidden w-100"
                        style="line-height: 1.3"
                      >
                        <p class="small mb-0 text-light">District</p>
                        <div
                          class="d-flex justify-content-between align-items-center"
                        >
                          <p class="mb-0 text-nowrap text-truncate text-white">
                            {{ currentDistrict ? currentDistrict.name : "All" }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </button>
                  <div
                    class="dropdown-menu dropdown-menu-right p-0"
                    aria-labelledby="dropdownMenuButton"
                    style="max-height: 150px; overflow-y: auto"
                  >
                    <button
                      class="dropdown-item font-weight-medium d-flex justify-content-between align-items-center py-2 px-3 btn-secondary border-outline-dark-bottom fs-8"
                      :class="
                        currentDistrict == null ? 'text-white' : 'text-light'
                      "
                      @click="currentDistrict = null"
                    >
                      All districts
                      <font-awesome-icon
                        :icon="['fas', 'check']"
                        class="text-primary ml-3 small"
                        v-if="currentDistrict == null"
                      />
                    </button>
                    <button
                      v-for="district in userDistricts.length
                        ? userDistricts
                        : allDistricts"
                      :key="district._id"
                      class="dropdown-item d-flex justify-content-between align-items-center py-2 px-3 btn-secondary border-outline-dark-bottom fs-8"
                      :class="
                        currentDistrict && currentDistrict._id == district._id
                          ? 'text-white'
                          : 'text-light'
                      "
                      @click="currentDistrict = district"
                    >
                      {{ district.name }}
                      <font-awesome-icon
                        :icon="['fas', 'check']"
                        class="text-primary ml-3 small"
                        v-if="
                          currentDistrict && currentDistrict._id == district._id
                        "
                      />
                    </button>
                  </div>
                </div>
              </div>
              <div
                class="col-6 px-0 border-right border-bottom border-outline-dark"
              >
                <button
                  class="btn btn-sm text-left d-flex rounded-0 justify-content-start align-items-center position-relative p-2 w-100 h-100"
                  type="button"
                  @click="showDateSelector = true"
                  data-placement="bottom"
                  title="Select date"
                  @mouseover="helper.showTooltip"
                  @mouseleave="helper.hideTooltip"
                >
                  <div class="mr-2">
                    <font-awesome-icon
                      :icon="['far', 'calendar-alt']"
                      :class="dateRange ? 'text-primary' : 'text-light'"
                    />
                    <font-awesome-icon
                      :icon="['fas', 'check-circle']"
                      class="text-success bg-dark rounded-circle"
                      style="
                        font-size: 0.85em;
                        position: absolute;
                        top: 1.55em;
                        right: 0.45em;
                      "
                      v-if="dateRange"
                    />
                  </div>
                  <div class="w-100 overflow-hidden" style="line-height: 1.3">
                    <p class="small mb-0 text-light">Date</p>
                    <p class="mb-0 text-nowrap text-truncate text-white">
                      {{ dateRange ? displayDateFilter : "All" }}
                    </p>
                  </div>
                </button>
              </div>
              <div
                class="col-6 px-0 border-bottom border-right border-outline-dark"
              >
                <div class="dropdown h-100">
                  <button
                    class="btn btn-sm btn-block no-focus position-relative rounded-0 py-0 px-2 d-flex justify-content-between align-items-center overflow-hidden dropdown-toggle text-light h-100"
                    type="button"
                    id="dropdownVerifiedButton"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    data-placement="bottom"
                    title="Select road"
                    @mouseover="helper.showTooltip"
                    @mouseleave="helper.hideTooltip"
                  >
                    <div
                      class="d-flex justify-content-start align-items-center w-100 py-2"
                    >
                      <div class="mr-2">
                        <font-awesome-icon
                          :icon="['fas', 'road']"
                          :class="currentRoad ? 'text-primary' : 'text-light'"
                        />
                        <font-awesome-icon
                          :icon="['fas', 'check-circle']"
                          class="text-success bg-dark rounded-circle"
                          style="
                            font-size: 0.85em;
                            position: absolute;
                            top: 1.55em;
                            right: 0.45em;
                          "
                          v-if="currentRoad"
                        />
                      </div>
                      <div
                        class="text-left overflow-hidden w-100"
                        style="line-height: 1.3"
                      >
                        <p class="small mb-0 text-light">Road</p>
                        <div
                          class="d-flex justify-content-between align-items-center"
                        >
                          <p class="mb-0 text-nowrap text-truncate text-white">
                            {{ currentRoad ? currentRoad.name : "All" }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </button>
                  <div
                    class="dropdown-menu dropdown-menu-right p-0"
                    aria-labelledby="dropdownMenuButton"
                    style="max-height: 200px; overflow-y: auto"
                  >
                    <input
                      type="text"
                      v-model="roadSearch"
                      class="form-control text-light border-0"
                      placeholder="Search road"
                      aria-label="Search road"
                    />
                    <button
                      class="dropdown-item d-flex justify-content-between align-items-center py-2 px-3 btn-secondary border-outline-dark-bottom fs-8 text-white"
                      @click="currentRoad = null"
                    >
                      All
                      <font-awesome-icon
                        :icon="['fas', 'check']"
                        class="text-primary ml-3 small"
                        v-if="currentRoad == null"
                      />
                    </button>
                    <button
                      class="dropdown-item d-flex justify-content-between align-items-center py-2 px-3 btn-secondary border-outline-dark-bottom fs-8 text-wrap"
                      v-for="road in computedRoads"
                      :key="road.id"
                      :class="
                        currentRoad && currentRoad.id == road.id
                          ? ' text-white'
                          : ' text-light'
                      "
                      @click="currentRoad = road"
                    >
                      {{ road.name }}
                      <font-awesome-icon
                        :icon="['fas', 'check']"
                        class="text-primary ml-3 small"
                        v-if="currentRoad && currentRoad.id == road.id"
                      />
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-6 px-0 border-bottom border-outline-dark">
                <div class="dropdown h-100">
                  <button
                    class="btn btn-sm btn-block no-focus position-relative rounded-0 py-0 px-2 d-flex justify-content-between align-items-center overflow-hidden dropdown-toggle text-light h-100"
                    type="button"
                    id="dropdownVerifiedButton"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    data-placement="bottom"
                    title="Select status"
                    @mouseover="helper.showTooltip"
                    @mouseleave="helper.hideTooltip"
                  >
                    <div
                      class="d-flex justify-content-start align-items-center w-100 py-2"
                    >
                      <div class="mr-2">
                        <font-awesome-icon
                          :icon="['fas', 'check-double']"
                          :class="
                            currentReviewStatus ? 'text-primary' : 'text-light'
                          "
                        />
                        <font-awesome-icon
                          :icon="['fas', 'check-circle']"
                          class="text-success bg-dark rounded-circle"
                          style="
                            font-size: 0.85em;
                            position: absolute;
                            top: 1.55em;
                            right: 0.45em;
                          "
                          v-if="currentReviewStatus"
                        />
                      </div>
                      <div
                        class="text-left overflow-hidden w-100"
                        style="line-height: 1.3"
                      >
                        <p class="small mb-0 text-light">Status</p>
                        <div
                          class="d-flex justify-content-between align-items-center"
                        >
                          <p class="mb-0 text-nowrap text-truncate text-white">
                            {{
                              reviewStatuses.find(
                                (rs) => rs.value == currentReviewStatus
                              ).label
                            }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </button>
                  <div
                    class="dropdown-menu dropdown-menu-right p-0"
                    aria-labelledby="dropdownMenuButton"
                    style="max-height: 200px; overflow-y: auto"
                  >
                    <button
                      class="dropdown-item d-flex justify-content-between align-items-center py-2 px-3 btn-secondary border-outline-dark-bottom fs-8"
                      v-for="status in reviewStatuses"
                      :key="`reviewStatus-${status.value || 'all'}`"
                      :class="
                        currentReviewStatus == status.value
                          ? ' text-white'
                          : ' text-light'
                      "
                      @click="currentReviewStatus = status.value"
                    >
                      {{ status.label }}
                      <font-awesome-icon
                        :icon="['fas', 'check']"
                        class="text-primary ml-3 small"
                        v-if="currentReviewStatus == status.value"
                      />
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-6 px-0 border-right border-outline-dark">
                <div class="dropdown h-100">
                  <button
                    class="btn btn-sm btn-block no-focus position-relative rounded-0 py-0 px-2 d-flex justify-content-between align-items-center overflow-hidden h-100"
                    :class="{ 'no-pseudo': contractorFilter }"
                    type="button"
                    id="dropdownFilterDefect"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    @click="
                      dropdownActive == 'contractor'
                        ? (dropdownActive = '')
                        : (dropdownActive = 'contractor')
                    "
                    @blur="dropdownActive = ''"
                    data-placement="bottom"
                    title="Select contractor"
                    @mouseover="helper.showTooltip"
                    @mouseleave="helper.hideTooltip"
                  >
                    <div
                      class="d-flex justify-content-start align-items-center w-100 py-2"
                    >
                      <div class="mr-2">
                        <font-awesome-icon
                          class="text-light"
                          :icon="['fas', 'hard-hat']"
                          :class="{ 'text-primary': contractorFilter }"
                        />
                        <font-awesome-icon
                          :icon="['fas', 'check-circle']"
                          class="text-success bg-dark"
                          style="
                            font-size: 0.85em;
                            position: absolute;
                            top: 1.55em;
                            right: 0.45em;
                          "
                          v-if="contractorFilter"
                        />
                      </div>
                      <div
                        class="text-left overflow-hidden w-100"
                        style="line-height: 1.3"
                      >
                        <p class="small mb-0 text-white">Contractor</p>

                        <div
                          class="d-flex justify-content-between align-items-center"
                        >
                          <p class="mb-0 text-nowrap text-truncate text-white">
                            {{
                              contractorFilter
                                ? contractors.find(
                                    (contractor) =>
                                      contractor._id == contractorFilter
                                  ).name
                                : "All"
                            }}
                          </p>
                          <font-awesome-icon
                            v-if="dropdownActive == 'contractor'"
                            class="text-white mr-1 angle-icon"
                            style="font-size: 0.65rem"
                            :icon="['fas', 'angle-up']"
                          />
                          <font-awesome-icon
                            v-else
                            class="text-white mr-1 angle-icon"
                            style="font-size: 0.65rem"
                            :icon="['fas', 'angle-down']"
                          />
                        </div>
                      </div>
                    </div>
                  </button>
                  <div
                    class="dropdown-menu dropdown-menu-right p-0"
                    aria-labelledby="dropdownMenuButton"
                    style="max-height: 120px; overflow-y: auto"
                  >
                    <button
                      class="dropdown-item font-weight-medium d-flex justify-content-between align-items-center py-2 px-3 btn-secondary border-outline-dark-bottom fs-8"
                      :class="
                        contractorFilter == null ? 'text-white' : 'text-light'
                      "
                      @click="contractorFilter = null"
                    >
                      All contractors
                      <font-awesome-icon
                        :icon="['fas', 'check']"
                        class="text-primary ml-3 small"
                        v-if="contractorFilter == null"
                      />
                    </button>
                    <button
                      v-for="contractor in contractors"
                      :key="`contractor-${contractor._id}`"
                      class="dropdown-item d-flex justify-content-between align-items-center py-2 px-3 btn-secondary border-outline-dark-bottom fs-8"
                      :class="
                        contractorFilter == contractor._id
                          ? 'text-white'
                          : 'text-light'
                      "
                      @click="contractorFilter = contractor._id"
                    >
                      {{ contractor.name }}
                      <font-awesome-icon
                        :icon="['fas', 'check']"
                        class="text-primary ml-3 small"
                        v-if="contractorFilter == contractor._id"
                      />
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-6 px-0 border-outline-dark">
                <div class="dropdown h-100">
                  <button
                    class="btn btn-sm btn-block no-focus position-relative rounded-0 py-0 px-2 d-flex justify-content-between align-items-center overflow-hidden h-100"
                    :class="{ 'no-pseudo': defectTypeFilter.length }"
                    type="button"
                    id="dropdownDefectTypeButton"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    @click="
                      dropdownActive == 'defectType'
                        ? (dropdownActive = '')
                        : (dropdownActive = 'defectType')
                    "
                    @blur="dropdownActive = ''"
                    data-placement="bottom"
                    title="Filter by defect type"
                    @mouseover="helper.showTooltip"
                    @mouseleave="helper.hideTooltip"
                  >
                    <div
                      class="d-flex justify-content-start align-items-center w-100 py-2"
                    >
                      <div class="mr-2">
                        <font-awesome-icon
                          class="text-light"
                          :icon="['fas', 'exclamation-triangle']"
                          :class="{ 'text-primary': defectTypeFilter.length }"
                        />
                        <font-awesome-icon
                          :icon="['fas', 'check-circle']"
                          class="text-success bg-dark"
                          style="
                            font-size: 0.85em;
                            position: absolute;
                            top: 1.55em;
                            right: 0.45em;
                          "
                          v-if="defectTypeFilter.length"
                        />
                      </div>
                      <div
                        class="text-left overflow-hidden w-100"
                        style="line-height: 1.3"
                      >
                        <p class="small mb-0 text-white">Defect Type</p>
                        <div
                          class="d-flex justify-content-between align-items-center"
                        >
                          <p class="mb-0 text-nowrap text-truncate text-white">
                            {{
                              defectTypeFilter.length === 0
                                ? "All"
                                : defectTypeFilter
                                    .map(formatDefectName)
                                    .join(", ")
                            }}
                          </p>
                          <font-awesome-icon
                            v-if="dropdownActive == 'defectType'"
                            class="text-white mr-1 angle-icon"
                            style="font-size: 0.65rem"
                            :icon="['fas', 'angle-up']"
                          />
                          <font-awesome-icon
                            v-else
                            class="text-white mr-1 angle-icon"
                            style="font-size: 0.65rem"
                            :icon="['fas', 'angle-down']"
                          />
                        </div>
                      </div>
                    </div>
                  </button>
                  <div
                    class="dropdown-menu dropdown-menu-right p-0 border-0"
                    aria-labelledby="dropdownDefectTypeButton"
                    style="max-height: 240px; overflow-y: auto"
                  >
                    <div
                      class="dropdown-item d-flex justify-content-between align-items-center py-2 px-3 btn-secondary border-outline-dark-bottom fs-8"
                      @click="handleClearDefectTypes"
                    >
                      <div class="custom-control custom-checkbox py-2">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          :checked="defectTypeFilter.length === 0"
                          @click.stop="handleClearDefectTypes"
                        />
                        <label
                          class="custom-control-label text-nowrap text-white fs-8"
                        >
                          All defect types
                        </label>
                      </div>
                    </div>
                    <div
                      v-if="typeOfDefects.length === 0"
                      class="px-3 py-2 fs-8 text-light"
                    >
                      No defect types in this window
                    </div>
                    <div
                      v-for="type in typeOfDefects"
                      :key="`defect-type-${type.value}`"
                      class="dropdown-item d-flex justify-content-between align-items-center py-2 px-3 btn-secondary border-outline-dark-bottom fs-8"
                      @click="(e) => handleDefectTypeToggle(e, type.value)"
                    >
                      <div class="custom-control custom-checkbox py-2">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          :id="`defect-type-${type.value}`"
                          :checked="defectTypeFilter.includes(type.value)"
                          @click.stop
                        />
                        <label
                          class="custom-control-label text-nowrap text-white fs-8"
                          :for="`defect-type-${type.value}`"
                        >
                          {{ type.label }}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <button
              class="btn btn-sm btn-block rounded-0 bg-dark-ds text-secondary"
              @click="hideFilter = !hideFilter"
              data-placement="bottom"
              @mouseover="helper.showTooltip"
              @mouseleave="helper.hideTooltip"
              :title="
                hideFilter ? 'Click to hide filter' : 'Click to show filter'
              "
            >
              <font-awesome-icon
                :icon="['fas', 'angle-up']"
                v-if="!hideFilter"
              />
              <font-awesome-icon :icon="['fas', 'angle-down']" v-else />
            </button>
          </div>
          <!-- dashcam filter end -->
          <div
            class="case-body rounded-0"
            :style="{
              height: hideFilter
                ? 'calc(100% - 43px - 72px + 8px)'
                : 'calc(100% - 43px - 176px - 79px + 14px)',
            }"
          >
            <div
              id="projectsListContainer"
              class="projects-list-container h-100"
            >
              <div
                class="case-list border-outline-dark-bottom"
                :id="video._id"
                :data-codec="video.videoCodec || 'not-specified'"
                v-for="video in videos"
                :key="video._id"
                :class="{
                  active: currentVideo && currentVideo._id == video._id,
                }"
                @click="goTo(video._id)"
              >
                <p class="small text-primary mb-0">
                  #{{ video.index }} {{ video.district && video.district.name }}
                </p>
                <p class="font-weight-bold mb-0 text-white">
                  {{ formatDate(video.datetime) }}
                </p>
                <p class="small text-light mb-1" v-if="video.road">
                  {{ helper.getRoadInfo(video.road) }}
                </p>
                <p class="small text-primary mb-1">
                  <span
                    class="mr-2"
                    v-if="
                      video.isProcessed &&
                      defectsMatchingFilter(video.defects) &&
                      defectsMatchingFilter(video.defects).length > 0
                    "
                  >
                    {{
                      defectsMatchingFilter(video.defects).length > 0
                        ? defectsMatchingFilter(video.defects).length
                        : "No"
                    }}
                    Defects found
                  </span>
                  <template v-else-if="!video.isProcessed">
                    <div class="spinner-border spinner-border-xs mr-1"></div>
                    Processing...
                  </template>
                  <span
                    class="mb-0 badge badge-success"
                    v-if="video.isProcessed && video.isReviewed"
                  >
                    <font-awesome-icon
                      :icon="['fas', 'check-circle']"
                      class="mr-1"
                    />Reviewed
                  </span>
                </p>
                <p class="small text-muted mb-0 user-select-none">
                  <font-awesome-icon
                    :icon="['fas', 'video']"
                    class="mr-2 text-primary"
                    @click.stop
                    @dblclick.stop="deleteVideo(video)"
                  />Dashcam
                </p>
              </div>
              <div
                class="p-4 d-flex justify-content-center align-items-center"
                v-if="videos.length > 0"
              >
                <p class="mb-0 font-italic text-muted">
                  End of
                  {{
                    currentPage == totalPage ? "list" : `page ${currentPage}`
                  }}
                </p>
              </div>
              <div
                class="p-4 d-flex justify-content-center align-items-center"
                v-else
              >
                <p class="mb-0 font-italic text-muted">
                  No dashcam video found
                </p>
              </div>
            </div>
          </div>
          <div class="case-footer row mx-0">
            <div
              class="col-6 px-0 small d-flex flex-column justify-content-center align-items-center text-muted"
              style="line-height: 1.1"
            >
              <small>
                <span class="font-weight-medium mr-2">
                  {{ totalVideoCount }}
                </span>
                <span>videos</span>
              </small>
              <!-- <small class="text-warning">
                <span class="font-weight-medium mr-2">
                  {{ totalDefectCount }}
                </span>
                <span>defects</span>
              </small> -->
            </div>
            <div class="col-6 px-0">
              <button
                class="btn btn-block btn-sm btn-primary py-2 rounded-0"
                @click="showMediaUploader = true"
                title="Click to upload video"
                data-toggle="tooltip"
                data-placement="right"
                @mouseover="helper.showTooltip"
                @mouseleave="helper.hideTooltip"
              >
                <font-awesome-icon :icon="['fas', 'upload']" class="mr-2" />
                Upload
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="col section-right text-truncate d-flex px-0 px-md-3">
        <div
          class="case-container bg-dashboard-dark-1 border-outline-dark w-100"
        >
          <div
            class="section-header bg-dashboard-dark-1 border-bottom border-outline-dark"
          >
            <button
              class="btn btn-outline-primary shadow-sm mr-3 section-left-toggler"
              @click="toggleSidebar()"
              data-placement="bottom"
              @mouseover="helper.showTooltip"
              @mouseleave="helper.hideTooltip"
              title="Click to open sidebar"
            >
              <font-awesome-icon :icon="['fas', 'angle-right']" />
            </button>
            <div
              v-if="currentVideo"
              class="w-100 d-flex justify-content-between align-items-center"
            >
              <div>
                <div class="text-uppercase text-white">
                  <font-awesome-icon
                    :icon="['fas', 'video']"
                    class="mr-2 text-primary"
                  />
                  {{ formatDate(currentVideo.datetime) }}
                  <span class="text-light" v-if="currentVideo.district">
                    &middot;
                    {{ currentVideo.district.name }}
                  </span>
                </div>
                <p
                  class="small text-muted mb-0 d-none d-md-block"
                  v-if="currentVideo.roadName"
                >
                  {{ currentVideo.roadName }}
                </p>
              </div>
              <div
                class="small text-capitalize text-muted"
                v-if="!currentVideo.isProcessed"
              >
                <div
                  class="spinner-border spinner-border-sm text-primary mr-1"
                ></div>
                Processing...
              </div>
              <div v-else class="small text-right">
                <p class="mb-1 text-light">
                  {{ defectsMatchingFilter(currentVideo.defects).length }} Defects
                  found
                </p>
                <button
                  class="btn btn-primary btn-sm py-0"
                  @click="setAsReviewed()"
                  v-if="!currentVideo.isReviewed"
                  title="Click to set as reviewed"
                  data-toggle="tooltip"
                  data-placement="right"
                  @mouseover="helper.showTooltip"
                  @mouseleave="helper.hideTooltip"
                >
                  <small>Set as Reviewed</small>
                </button>
                <p class="mb-0 badge badge-success" v-else>
                  <font-awesome-icon
                    :icon="['fas', 'check-circle']"
                    class="mr-1"
                  />Reviewed
                </p>
              </div>
            </div>
            <p
              v-else
              class="font-weight-normal small mb-0 font-italic flex-grow-1 text-center text-light"
            >
              No dashcam video selected
            </p>
          </div>
          <div
            id="reportBody"
            class="dashcam-body"
            :class="{
              'no-defect':
                currentVideo &&
                filteredDefects(currentVideo.defects).length < 1,
            }"
            v-if="currentVideo"
          >
            <div class="dashcam-video position-relative shadow-sm">
              <div
                class="dashcam-map border-outline-dark bg-dashboard-dark-1"
                :class="{
                  invisible:
                    !currentVideo.coordinates ||
                    currentVideo.coordinates.length < 1,
                }"
              >
                <div
                  id="video-map"
                  class="h-100 w-100 rounded overflow-hidden"
                ></div>
              </div>
              <!-- <video
                :src="
                  currentVideo.processedVideo && currentVideo.defects.length
                    ? currentVideo.processedVideo
                    : helper.formatMediaUrl(currentVideo.video)
                "
                @timeupdate="videoPlaying"
                controls
                muted
                playsinline
              /> -->
              <video
                v-if="currentVideo.isProcessed"
                ref="videoPlayer"
                :src="currentVideoSrc"
                @timeupdate="videoPlaying"
                controls
                autoplay
                loop
                muted
                playsinline
              />
              <div v-else class="text-center text-light" style="z-index: 1">
                <div
                  class="spinner-border spinner-border-sm text-primary mb-2"
                ></div>
                <p class="mb-0">Video is still processing</p>
                <p class="mb-0 small text-muted">
                  This can take a while - check back later
                </p>
              </div>
            </div>
            <div class="dashcam-footer" :class="{ expanded: footerExpanded }">
              <div class="d-flex bg-dashboard-dark-1 border-bottom border-dark">
                <div class="dropdown" style="width: 150px">
                  <button
                    class="btn btn-sm btn-block no-focus position-relative rounded-0 py-0 px-2 d-flex justify-content-between align-items-center overflow-hidden"
                    type="button"
                    id="dropdownPerVideoDefectFilter"
                    :data-toggle="perVideoFilterDisabled ? '' : 'dropdown'"
                    aria-haspopup="true"
                    aria-expanded="false"
                    :disabled="perVideoFilterDisabled"
                    @click="
                      perVideoFilterDisabled
                        ? null
                        : dropdownActive == 'perVideoDefect'
                        ? (dropdownActive = '')
                        : (dropdownActive = 'perVideoDefect')
                    "
                    @blur="dropdownActive = ''"
                    data-placement="bottom"
                    @mouseover="helper.showTooltip"
                    @mouseleave="helper.hideTooltip"
                    :title="
                      perVideoFilterDisabled
                        ? 'Disabled while a single defect type is selected above'
                        : 'Narrow markers on this video'
                    "
                  >
                    <div
                      class="d-flex justify-content-start align-items-center w-100 py-2"
                    >
                      <div class="mr-2">
                        <font-awesome-icon
                          class="text-light"
                          :icon="['fas', 'hard-hat']"
                          :class="{ 'text-primary': perVideoDefectFilter }"
                        />
                        <font-awesome-icon
                          :icon="['fas', 'check-circle']"
                          class="text-success bg-dark"
                          style="
                            font-size: 0.85em;
                            position: absolute;
                            top: 1.55em;
                            right: 0.45em;
                          "
                          v-if="perVideoDefectFilter"
                        />
                      </div>
                      <div
                        class="text-left overflow-hidden w-100"
                        style="line-height: 1.3"
                      >
                        <p class="small mb-0 text-white">This video</p>
                        <div
                          class="d-flex justify-content-between align-items-center"
                        >
                          <p class="mb-0 text-nowrap text-truncate text-white">
                            {{
                              perVideoFilterDisabled
                                ? "—"
                                : perVideoDefectFilter
                                ? (videoDefectTypeOptions.find(
                                    (t) => t.value == perVideoDefectFilter
                                  ) || {
                                    label: formatDefectName(
                                      perVideoDefectFilter
                                    ),
                                  }).label
                                : "All"
                            }}
                          </p>
                          <font-awesome-icon
                            v-if="dropdownActive == 'perVideoDefect'"
                            class="text-white mr-1 angle-icon"
                            style="font-size: 0.65rem"
                            :icon="['fas', 'angle-up']"
                          />
                          <font-awesome-icon
                            v-else
                            class="text-white mr-1 angle-icon"
                            style="font-size: 0.65rem"
                            :icon="['fas', 'angle-down']"
                          />
                        </div>
                      </div>
                    </div>
                  </button>
                  <div
                    class="dropdown-menu dropdown-menu-right p-0"
                    aria-labelledby="dropdownPerVideoDefectFilter"
                    style="max-height: 240px; overflow-y: auto"
                  >
                    <button
                      class="dropdown-item font-weight-medium d-flex justify-content-between align-items-center py-2 px-3 btn-secondary border-outline-dark-bottom fs-8"
                      :class="
                        perVideoDefectFilter == null ? 'text-white' : 'text-light'
                      "
                      @click="perVideoDefectFilter = null"
                    >
                      All Defects
                      <font-awesome-icon
                        :icon="['fas', 'check']"
                        class="text-primary ml-3 small"
                        v-if="perVideoDefectFilter == null"
                      />
                    </button>
                    <button
                      v-for="type in videoDefectTypeOptions"
                      :key="`per-video-${type.value}`"
                      class="dropdown-item d-flex justify-content-between align-items-center py-2 px-3 btn-secondary border-outline-dark-bottom text-capitalize"
                      :class="
                        perVideoDefectFilter == type.value
                          ? 'text-white'
                          : 'text-light'
                      "
                      @click="perVideoDefectFilter = type.value"
                    >
                      {{ type.label }}
                      <font-awesome-icon
                        :icon="['fas', 'check']"
                        class="text-primary ml-3 small"
                        v-if="perVideoDefectFilter == type.value"
                      />
                    </button>
                  </div>
                </div>
              </div>
              <button
                class="btn btn-sm btn-dark rounded-circle btn-toggler"
                @click="footerExpanded = !footerExpanded"
                data-placement="bottom"
                @mouseover="helper.showTooltip"
                @mouseleave="helper.hideTooltip"
                title="Click to view more"
              >
                <font-awesome-icon :icon="['fas', 'angle-down']" />
              </button>
              <div class="dashcam-defects show-scroll bg-dashboard-dark-1">
                <div v-for="defect in filterDefectByType" :key="defect._id">
                  <div class="img-container">
                    <img
                      :src="
                        defect.annotatedImage
                          ? helper.formatMediaUrl(defect.annotatedImage)
                          : helper.formatMediaUrl(defect.image)
                      "
                      @click="currentDefect = defect"
                      data-placement="bottom"
                      @mouseover="helper.showTooltip"
                      @mouseleave="helper.hideTooltip"
                      title="Click to view image"
                    />
                    <font-awesome-icon
                      :icon="['fas', 'check-circle']"
                      class="text-success"
                      style="position: absolute; top: 5px; right: 5px"
                      v-if="defect.case"
                    />
                    <button
                      class="btn btn-sm btn-danger"
                      style="
                        position: absolute;
                        top: 5px;
                        left: 5px;
                        font-size: 70%;
                      "
                      @click="deleteDefect(defect._id)"
                      data-placement="bottom"
                      @mouseover="helper.showTooltip"
                      @mouseleave="helper.hideTooltip"
                      title="Click to delete"
                    >
                      <font-awesome-icon :icon="['fas', 'trash-alt']" />
                    </button>
                  </div>
                  <div class="defect-info">
                    <div
                      class="d-flex justify-content-start align-items-center text-white"
                    >
                      <small>{{ formatDate(defect.datetime) }}</small>
                    </div>
                    <div
                      class="action text-success"
                      v-if="caseAction && caseAction.defect._id == defect._id"
                    >
                      <button
                        class="btn btn-link btn-sm text-light"
                        @click="caseAction = null"
                        data-placement="bottom"
                        @mouseover="helper.showTooltip"
                        @mouseleave="helper.hideTooltip"
                        title="Click to cancel"
                      >
                        <small>Cancel</small>
                      </button>
                      <button
                        class="btn btn-link btn-sm"
                        :class="
                          caseAction.type == 'add'
                            ? 'text-success'
                            : 'text-danger'
                        "
                        @click="doCaseAction(caseAction.type, defect)"
                        data-placement="bottom"
                        @mouseover="helper.showTooltip"
                        @mouseleave="helper.hideTooltip"
                        title="Click to confirm"
                      >
                        <small class="font-weight-medium">Confirm</small>
                      </button>
                    </div>
                    <div class="input" v-else>
                      <a
                        data-toggle="tooltip"
                        data-placement="right"
                        @mouseover="helper.showTooltip"
                        @mouseleave="helper.hideTooltip"
                        v-if="defect.case"
                        title="Remove from case"
                        ><font-awesome-icon
                          :icon="['fas', 'minus']"
                          class="text-danger mr-1"
                          @click="removeFromCase(defect)"
                      /></a>
                      <a
                        v-else
                        title="Add to case"
                        data-toggle="tooltip"
                        data-placement="right"
                        @mouseover="helper.showTooltip"
                        @mouseleave="helper.hideTooltip"
                        @click="addToCase(defect)"
                      >
                        <font-awesome-icon
                          :icon="['fas', 'plus']"
                          class="text-success mr-1"
                        />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <spinner v-if="isProcessing" />
    <media-preview
      v-if="currentDefect"
      :url="
        currentDefect.annotatedImage
          ? helper.formatMediaUrl(currentDefect.annotatedImage)
          : helper.formatMediaUrl(currentDefect.image)
      "
      :subtitle="`Defect`"
      :title="`${formatDate(currentDefect.datetime)}`"
      :showMap="true"
      :defect="currentDefect"
      :showControl="{
        delete: true,
        add: currentDefect && !currentDefect.case,
        remove: currentDefect && currentDefect.case,
      }"
      :hasNavigation="{
        previous: getCurrentDefectIndex() > 0,
        next:
          getCurrentDefectIndex() <
          filteredDefects(currentVideo.defects).length - 1,
      }"
      @close="currentDefect = null"
      @delete="deleteDefect($event._id)"
      @add="doCaseAction('add', $event)"
      @remove="doCaseAction('remove', $event)"
      @navigate="navigateMediaPreview"
    />
    <media-uploader
      v-if="showMediaUploader"
      :districts="userDistricts.length > 0 ? userDistricts : allDistricts"
      :districtFrom="userDistricts.length > 0 ? 'user' : 'all'"
      @uploaded="appendNewVideo"
      @close="showMediaUploader = false"
    />
    <road-selector
      v-if="showRoadSelector"
      :districts="userDistricts.length > 0 ? userDistricts : allDistricts"
      :videoDistrict="currentVideo && currentVideo.district"
      :lat="showRoadSelector && showRoadSelector.lat"
      :lng="showRoadSelector && showRoadSelector.lng"
      @close="roadSelected"
    />
    <date-selector
      v-if="showDateSelector"
      :dateRange="dateRange"
      :isRange="true"
      @close="dateSelected"
    />
  </div>
</template>

<script>
import Swal from "sweetalert2";
import Moment from "moment";
import API from "@/api";
import Helper from "@/helper";
import Spinner from "@/components/Spinner";
import MediaPreview from "@/components/MediaPreview";
import MediaUploader from "@/components/MediaUploader";
import RoadSelector from "@/components/RoadSelector";
import DateSelector from "@/components/DateSelector";
import "mapbox-gl";

const lastWeek = Moment()
  .subtract(1, "week")
  .startOf("day")
  .format("YYYY-MM-DD");
const today = Moment().endOf("day").format("YYYY-MM-DD");

export default {
  name: "dashcam",
  components: {
    Spinner,
    MediaPreview,
    MediaUploader,
    RoadSelector,
    DateSelector,
  },
  data() {
    return {
      typeOfDefects: [],
      allRoads: [],
      roadSearch: null,
      currentRoad: null,
      helper: Helper,
      map: null,
      mapMarker: null,
      isProcessing: false,
      showSidebar: false,
      showMediaUploader: false,
      showRoadSelector: false,
      showDateSelector: false,
      videos: [],
      currentVideo: null,
      footerExpanded: false,
      currentDefect: null,
      caseAction: null,
      aiUser: null,
      userDistricts: [],
      userRole: null,
      allDistricts: [],
      updateVideoStatus: null,
      currentDistrict: null,
      currentWorkscope: null,
      dateRange: { start: lastWeek, end: today },
      currentPage: 1,
      pageLimit: 100,
      totalPage: 1,
      inputPage: 1,
      totalVideoCount: 0,
      totalDefectCount: 0,
      currentCategory: null,
      reviewStatuses: [
        {
          label: "All",
          value: null,
        },
        {
          label: "Reviewed",
          value: "reviewed",
        },
        {
          label: "Pending Review",
          value: "pending_reviewed",
        },
        {
          label: "Pending Process",
          value: "pending_process",
        },
      ],
      currentReviewStatus: "pending_reviewed",
      contractorFilter: null,
      contractors: [],
      dropdownActive: "",
      hideFilter: false,
      defectTypeFilter: [],
      perVideoDefectFilter: null,
      newVideoCount: 0,
    };
  },
  watch: {
    showMediaUploader: {
      handler() {
        if (!this.showMediaUploader && this.newVideoCount) {
          // Fresh uploads are unprocessed, so they only appear under
          // "Pending Process" - switch to it or the upload looks like it
          // failed. Changing the status refetches via its own watcher.
          if (this.currentReviewStatus == "pending_process") {
            this.getVideos();
          } else {
            this.currentReviewStatus = "pending_process";
          }
        }
      },
    },
    footerExpanded: {
      handler() {
        const player = this.$refs.videoPlayer;

        if (!player) return;

        if (this.footerExpanded) {
          player.pause();
        } else {
          if (player.paused) {
            player.play();
          }
        }
      },
    },
    currentRoad: {
      handler() {
        this.roadSearch = null;

        this.getVideos();
        this.fetchDefectTypes();
      },
      immediate: false,
    },
    currentDistrict: {
      handler() {
        this.currentRoad = null;
        this.getRoads();
        this.getVideos();
        this.fetchDefectTypes();
      },
      immediate: false,
    },
    currentReviewStatus: {
      handler() {
        this.getVideos();
        this.fetchDefectTypes();
      },
      immediate: false,
    },
    contractorFilter: {
      handler() {
        this.getVideos();
        this.fetchDefectTypes();
      },
      immediate: false,
    },
    defectTypeFilter: {
      handler() {
        this.currentPage = 1;
        this.perVideoDefectFilter = null;
        this.getVideos();
      },
      immediate: false,
    },
    currentVideo: {
      handler() {
        this.perVideoDefectFilter = null;
      },
      immediate: false,
    },
  },
  computed: {
    computedRoads() {
      let _roads = JSON.parse(JSON.stringify(this.allRoads));

      if (this.roadSearch) {
        _roads = _roads.filter((r) =>
          r.name.toLowerCase().includes(this.roadSearch.toLowerCase())
        );
      }

      return _roads;
    },
    filterDefectByType() {
      const defects = this.defectsMatchingFilter(this.currentVideo?.defects);

      if (this.perVideoDefectFilter && !this.perVideoFilterDisabled)
        return defects.filter(
          (d) => d.name && d.name.includes(this.perVideoDefectFilter)
        );

      return defects;
    },
    videoDefectTypeOptions() {
      const defects = this.defectsMatchingFilter(this.currentVideo?.defects);
      const seen = [];

      defects.forEach((d) => {
        const name = d.name && d.name.split(",")[0];
        if (name && !seen.find((o) => o.value === name)) {
          seen.push({ label: this.formatDefectName(name), value: name });
        }
      });

      return seen;
    },
    perVideoFilterDisabled() {
      return this.defectTypeFilter && this.defectTypeFilter.length === 1;
    },
    displayDateFilter() {
      if (this.dateRange) {
        if (this.dateRange.start == this.dateRange.end) {
          return Moment(this.dateRange.start).format("D MMM YYYY");
        } else if (
          Moment(this.dateRange.start).format("MM-YYYY") ==
          Moment(this.dateRange.end).format("MM-YYYY")
        ) {
          return `${Moment(this.dateRange.start).format("D")} - ${Moment(
            this.dateRange.end
          ).format("D MMM YYYY")}`;
        } else if (
          Moment(this.dateRange.start).format("YYYY") ==
          Moment(this.dateRange.end).format("YYYY")
        ) {
          return `${Moment(this.dateRange.start).format("D MMM")} - ${Moment(
            this.dateRange.end
          ).format("D MMM YYYY")}`;
        } else {
          return `${Moment(this.dateRange.start).format(
            "D MMM YYYY"
          )} - ${Moment(this.dateRange.end).format("D MMM YYYY")}`;
        }
      } else {
        return null;
      }
    },
    currentVideoSrc() {
      if (this.currentVideo) {
        // Prefer processedVideo when available (covers HEVC, videos with defects, and new format)
        if (this.currentVideo.processedVideo) {
          return this.currentVideo.processedVideo;
        }
        // Fallback to original video (handles both Strapi upload object and string URL)
        if (typeof this.currentVideo.video !== "undefined") {
          return Helper.formatMediaUrl(this.currentVideo.video);
        }
        return "";
      } else {
        return "";
      }
    },
  },
  methods: {
    deleteVideo(video) {
      if (!video || this.userRole != "Super Admin") return;

      Swal.fire({
        html: `Delete video #${video.index}?`,
        icon: "question",
        confirmButtonText: "Delete",
        showCancelButton: true,
        buttonsStyling: false,
        reverseButtons: true,
        customClass: {
          confirmButton: "btn btn-sm btn-danger",
          cancelButton: "btn btn-sm btn-link",
          actions: "d-flex justify-content-between align-items-center",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.isProcessing = true;

          await API.delete(`dashcamvideos/${video._id}`);

          this.videos = this.videos
            .filter((v) => v._id !== video._id)
            .map((v, index) => {
              v.index = (this.currentPage - 1) * this.pageLimit + index + 1;

              return v;
            });

          this.currentVideo = null;

          this.isProcessing = false;
        }
      });
    },
    async getRoads() {
      this.allRoads = [];
      let url = "roadsOnly?_limit=-1";
      if (this.currentDistrict) {
        url += `&district=${this.currentDistrict.name}`;
      }
      await API.get(url).then((response) => {
        this.allRoads = response.data;
      });
    },
    filteredDefects(defects) {
      // console.log(defects)
      if (defects){
        // let filterOuts = ["Faded_Road_Line", 'Illegal_Dumping','Bunting']
        return defects.filter(
          (defect) => defect.isApproved
        );
      } else return [];

      // return defects ? defects : [];
    },
    formatDefectName(name) {
      if (!name) return "";
      return String(name)
        .replace(/_/g, " ")
        .toLowerCase()
        .replace(/\b\w/g, (c) => c.toUpperCase());
    },
    defectsMatchingFilter(defects) {
      const approved = this.filteredDefects(defects);

      if (!this.defectTypeFilter || !this.defectTypeFilter.length) return approved;

      return approved.filter((d) =>
        this.defectTypeFilter.some((t) => d.name && d.name.includes(t))
      );
    },

    setAsReviewed() {
      if (!this.currentVideo) return;

      Swal.fire({
        html: "Finish reviewing this video?",
        icon: "question",
        confirmButtonText: "Confirm",
        showCancelButton: true,
        buttonsStyling: false,
        reverseButtons: true,
        customClass: {
          confirmButton: "btn btn-sm btn-success",
          cancelButton: "btn btn-sm btn-link",
          actions: "d-flex justify-content-between align-items-center",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.isProcessing = true;

          API.put(`dashcamvideos/${this.currentVideo._id}`, {
            isReviewed: true,
          })
            .then(async () => {
              this.isProcessing = false;

              let video = this.videos.find(
                (v) => v._id == this.currentVideo._id
              );

              video.isReviewed = true;

              this.currentDefect = null;

              await this.getVideos();

              Swal.fire("", "Video marked as Reviewed", "success");
            })
            .catch((err) => {
              this.isProcessing = false;

              console.error(err);

              Swal.fire("", "Error marking video", "error");
            });
        }
      });
    },
    scrollListToTop() {
      const container = document.getElementById("projectsListContainer");

      if (container) {
        container.scrollTo(0, 0);
      }
    },
    changePage(page) {
      const x = parseInt(page);

      if (x != this.currentPage) {
        if (x > this.totalPage || x < 1) {
          this.inputPage = this.currentPage;
        } else {
          this.currentPage = x;
          this.inputPage = x;
        }

        this.getVideos("changePage");
      }
    },
    videoPlaying(e) {
      if (
        this.currentVideo &&
        this.currentVideo.coordinates &&
        this.currentVideo.coordinates.length > 0
      ) {
        let currentTime = Math.floor(e.srcElement.currentTime);

        let currentCoord = this.currentVideo.coordinates[currentTime];

        if (currentCoord) {
          this.setMapCenter(currentCoord[1], currentCoord[0]);
        }
      }
    },
    async initMap() {
      return new Promise((resolve) => {
        if (this.map) {
          if (
            this.currentVideo &&
            this.currentVideo.coordinates &&
            this.currentVideo.coordinates.length > 0
          ) {
            this.setMapCenter(
              this.currentVideo.coordinates[0][1],
              this.currentVideo.coordinates[0][0],
              "jump"
            );
          }

          this.map.resize();

          resolve();
        } else {
          mapboxgl.accessToken = process.env.VUE_APP_MAPBOX_KEY;

          this.map = new mapboxgl.Map({
            container: "video-map",
            style: "mapbox://styles/mapbox/dark-v11",
            zoom: 14,
            interactive: false,
          });

          this.map.addControl(
            new mapboxgl.NavigationControl({ class: "d-flex" })
          );

          this.map.on("load", () => {
            if (
              this.currentVideo &&
              this.currentVideo.coordinates &&
              this.currentVideo.coordinates.length > 0
            ) {
              this.setMapCenter(
                this.currentVideo.coordinates[0][1],
                this.currentVideo.coordinates[0][0],
                "jump"
              );
            }

            this.map.resize();

            resolve();
          });
        }
      });
    },
    async setMapCenter(lng, lat, type) {
      if (this.map) {
        if (this.mapMarker) {
          this.mapMarker.remove();

          this.mapMarker = null;
        }

        let el = document.createElement("div");

        el.className = "pin";

        this.mapMarker = new mapboxgl.Marker(el).setLngLat([lng, lat]);

        this.mapMarker.addTo(this.map);

        if (type == "jump") {
          this.map.setCenter([lng, lat]);
        } else {
          this.map.flyTo({
            center: [lng, lat],
            curve: 0.1,
            easing: function (t) {
              return t;
            },
            essential: true,
          });
        }
      }
    },
    getCurrentDefectIndex() {
      return this.filteredDefects(this.currentVideo?.defects).findIndex(
        (defect) => defect._id == this.currentDefect._id
      );
    },
    navigateMediaPreview(e) {
      if (this.currentDefect && this.currentVideo) {
        const currentDefectIndex = this.getCurrentDefectIndex();

        if (e == "previous" && currentDefectIndex > 0) {
          this.currentDefect = null;

          this.$nextTick(() => {
            this.currentDefect = this.filteredDefects(
              this.currentVideo?.defects
            )[currentDefectIndex - 1];
          });
        } else if (
          e == "next" &&
          currentDefectIndex <
            this.filteredDefects(this.currentVideo?.defects).length - 1
        ) {
          this.currentDefect = null;

          this.$nextTick(() => {
            this.currentDefect = this.filteredDefects(
              this.currentVideo?.defects
            )[currentDefectIndex + 1];
          });
        }
      }
    },
    dateSelected(e) {
      if (typeof e == "object") {
        this.dateRange = {
          start: Moment(e.start).format("YYYY-MM-DD"),
          end: Moment(e.end).format("YYYY-MM-DD"),
        };

        this.getVideos();
        this.fetchDefectTypes();
      } else if (typeof e == "boolean" && e == false) {
        this.dateRange = null;

        this.getVideos();
        this.fetchDefectTypes();
      }

      this.showDateSelector = null;
    },
    handleClearDefectTypes(e) {
      if (e && e.stopPropagation) e.stopPropagation();

      if (this.defectTypeFilter.length === 0) return;

      this.defectTypeFilter = [];
    },
    handleDefectTypeToggle(e, name) {
      if (e && e.preventDefault) e.preventDefault();

      const idx = this.defectTypeFilter.indexOf(name);

      if (idx >= 0) {
        const next = this.defectTypeFilter.slice();
        next.splice(idx, 1);
        this.defectTypeFilter = next;
      } else {
        this.defectTypeFilter = this.defectTypeFilter.concat([name]);
      }
    },
    async fetchDefectTypes() {
      const baseUrl = this.dashcamEndpoint("count");
      const queryStr = baseUrl
        .replace(/^dashcamvideos\/count\??/, "")
        .replace(/&$/, "");
      const sep = queryStr ? "&" : "";
      const url = `dashcamvideos/defect-types?${queryStr}${sep}isApproved=true`;

      try {
        const res = await API.get(url);
        const items = Array.isArray(res.data) ? res.data : [];

        this.typeOfDefects = items
          .map((item) => {
            const name = (item && item.name) || "";
            const pretty = this.formatDefectName(name);
            const label =
              item && item.count != null ? `${pretty} (${item.count})` : pretty;
            return { label, value: name };
          })
          .filter((item) => item.value);
      } catch (err) {
        console.error("fetchDefectTypes failed; defect-type dropdown will be empty until the backend endpoint is live.", err);
        this.typeOfDefects = [];
      }
    },
    deleteDefect(id) {
      Swal.fire({
        html: "Confirm delete defect?",
        icon: "question",
        confirmButtonText: "Confirm",
        showCancelButton: true,
        buttonsStyling: false,
        reverseButtons: true,
        customClass: {
          confirmButton: "btn btn-sm btn-danger",
          cancelButton: "btn btn-sm btn-link",
          actions: "d-flex justify-content-between align-items-center",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.isProcessing = true;

          API.delete(`defects/${id}`)
            .then(() => {
              this.isProcessing = false;

              let video = this.videos.find(
                (v) => v._id == this.currentVideo._id
              );

              video.defects = this.filteredDefects(video.defects).filter(
                (d) => d._id != id
              );

              this.currentDefect = null;

              Swal.fire("", "Defect deleted", "success");
            })
            .catch((err) => {
              this.isProcessing = false;

              console.error(err);

              Swal.fire("", "Error deleting defect", "error");
            });
        }
      });
    },
    appendNewVideo(data) {
      if (data) this.newVideoCount += 1;
    },
    doCaseAction(type, defect) {
      if (type == "remove") {
        this.isProcessing = true;

        this.caseAction = false;

        API.delete(`cases/${defect.case}`)
          .then(() => {
            defect.case = null;

            this.isProcessing = false;
          })
          .catch((err) => {
            console.error(err);

            this.isProcessing = false;
          });
      } else if (type == "add") {
        // if (
        //   this.currentVideo.roadName &&
        //   this.currentVideo.roadName != "Unnamed Road"
        // ) {
        //   defect.roadName = this.currentVideo.roadName;
        // }

        let options = {};

        Helper.workCategories().forEach((category) => {
          options[category] = category.split("_").join(" ");
        });

        let workScopes = [
          "R01",
          "R02",
          "R03",
          "R04",
          "R05",
          "R06",
          "R07",
          "R011",
        ];
        let workScopeOptions = {};
        workScopes.forEach((scope) => {
          workScopeOptions[scope] = scope;
        });

        Swal.fire({
          title: "Select work category",
          showCancelButton: true,
          confirmButtonText: "Select",
          reverseButtons: true,
          input: "select",
          inputOptions: options,
          customClass: {
            confirmButton: "btn btn-sm btn-primary mx-2",
            cancelButton: "btn btn-sm btn-light mx-2",
            input: "custom-select",
          },
          buttonsStyling: false,
        }).then((result) => {
          if (result.isConfirmed) {
            this.currentCategory = result.value;

            // this.showRoadSelector = defect;
            Swal.fire({
              title: "Select work scope",
              showCancelButton: true,
              confirmButtonText: "Select",
              reverseButtons: true,
              input: "select",
              inputOptions: workScopeOptions,
              customClass: {
                confirmButton: "btn btn-sm btn-primary mx-2",
                cancelButton: "btn btn-sm btn-light mx-2",
                input: "custom-select",
              },
              buttonsStyling: false,
            }).then((result) => {
              if (result.isConfirmed) {
                this.currentWorkscope = result.value;

                this.showRoadSelector = defect;
              } else {
                this.currentCategory = null;
                this.currentWorkscope = null;

                this.caseAction = false;
              }
            });
          } else {
            this.currentCategory = null;

            this.caseAction = false;
          }
        });
      }
    },
    async roadSelected(e) {
      const defect = { ...this.showRoadSelector };

      this.showRoadSelector = false;

      if (e) {
        this.isProcessing = true;

        const body = {
          source: "agent",
          type: "ai",
          status: "received",
          lat: defect.lat,
          lng: defect.lng,
          caption: `[Automated] ${defect.name} detected via Dashcam`,
          timestamp: defect.datetime,
          media: defect.annotatedImage
            ? (defect.annotatedImage._id || defect.annotatedImage)
            : (defect.image._id || defect.image),
          user: "5f01ea9f2a516a6379e9880b", //this.aiUser,
          road: e._id,
          defect: defect._id,
          district: e.daerah,
          reportType: this.currentWorkscope,
          category: this.currentCategory.split(" ").join("_"),
        };

        if (this.currentVideo.contractor) {
          body.contractor = this.currentVideo.contractor;
        }

        await API.post("cases", body)
          .then((retVal) => {
            let _defect = this.filteredDefects(this.currentVideo?.defects).find(
              (_defect) => _defect._id == defect._id
            );

            _defect.case = retVal.data._id;

            this.isProcessing = false;
          })
          .catch((err) => {
            console.error(err);

            this.isProcessing = false;
          });
      }

      this.currentCategory = null;
      this.currentWorkscope = null;

      this.caseAction = false;
    },
    addToCase(defect) {
      this.caseAction = { type: "add", defect };
    },
    removeFromCase(defect) {
      this.caseAction = { type: "remove", defect };
    },
    formatDate(date) {
      if (!date) {
        return "";
      } else {
        return Moment(date).format("D MMM YYYY, h:mm A");
      }
    },
    toggleSidebar() {
      this.showSidebar = !this.showSidebar;
    },
    async goTo(id) {
      this.footerExpanded = false;

      this.showSidebar = false;

      this.currentDefect = null;

      this.caseAction = null;

      this.showMediaUploader = false;

      let _currentVideo = this.videos.find((video) => video._id == id);

      if (
        _currentVideo &&
        _currentVideo.coordinates &&
        _currentVideo.coordinates.length > 0
      ) {
        _currentVideo.coordinates = _currentVideo.coordinates.filter(
          (_, index) => index % 2 !== 0
        );
      }

      if (
        _currentVideo &&
        !_currentVideo.roadName &&
        this.filteredDefects(_currentVideo.defects) &&
        this.filteredDefects(_currentVideo.defects).length > 0
      ) {
        const defectWithRoad = this.filteredDefects(_currentVideo.defects).find(
          (defect) => defect.road
        );

        if (defectWithRoad) {
          _currentVideo.roadName = await this.getRoadName(defectWithRoad.road);
        }
      } else if (!_currentVideo.roadName) {
        _currentVideo.roadName = await this.getRoadnameFromGMaps(_currentVideo);
      }

      this.currentVideo = _currentVideo;

      this.$nextTick(() => {
        this.initMap();
      });
    },
    getRoadnameFromGMaps(_currentVideo) {
      return new Promise(async (resolve) => {
        if (!_currentVideo.coordinates || _currentVideo.coordinates.length < 1)
          return resolve(null);

        const coords = _currentVideo.coordinates[0];

        if (coords[0] && coords[1]) {
          const retVal = await API.get(
            `dashcamvideos/road?lat=${coords[0]}&lng=${coords[1]}`
          );

          resolve(retVal.data.roadName);
        } else {
          resolve("");
        }
      });
    },
    async getRoadName(id) {
      return API.get(`roads/${id}`)
        .then((retVal) => {
          return retVal.data.name;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    async getTotalVideoCount() {
      return API.get(this.dashcamEndpoint("count"))
        .then((retVal) => {
          this.totalVideoCount = retVal.data;

          return;
        })
        .catch((err) => {
          console.error(err);

          return;
        });
    },
    dashcamEndpoint(type) {
      let url = type == "count" ? "dashcamvideos/count?" : "dashcamvideos?";

      if (this.dateRange) {
        const start = Moment(this.dateRange.start).startOf("day").toISOString();
        const end = Moment(this.dateRange.end).endOf("day").toISOString();

        url += `datetime_gte=${start}&datetime_lte=${end}&`;
      }

      let _districts = this.userDistricts.length
        ? this.userDistricts
        : this.allDistricts;

      if (this.contractorFilter) {
        if (this.contractorFilter == "612c5e628487e623af876e8a") {
          url += `contractor=${this.contractorFilter}&`;

          if (this.currentDistrict) {
            _districts = [this.currentDistrict];
          }
        } else {
          let _contractor = "contractor_null=true&";

          const currentContractor = this.contractors.find(
            (contractor) => contractor._id == this.contractorFilter
          );

          if (this.currentDistrict) {
            if (
              currentContractor.districts.find(
                (d) => d == this.currentDistrict._id
              )
            ) {
              _districts = [this.currentDistrict];
            } else {
              _contractor = `contractor=${this.contractorFilter}&`;

              _districts = [];
            }
          } else {
            _districts = currentContractor.districts.map((d) => {
              return { _id: d };
            });
          }

          url += _contractor;
        }
      } else {
        if (this.currentDistrict) {
          _districts = [this.currentDistrict];
        }
      }

      _districts.forEach((district) => {
        url += `district_in=${district._id}&`;
      });

      if (this.currentReviewStatus == "pending_process") {
        url += `isProcessed=false&`;
      } else if (this.currentReviewStatus) {
        // Reviewed / Pending Review only make sense once processing is done.
        // isProcessed_ne=false (not =true) so older records that predate the
        // flag are still treated as processed.
        url += `isProcessed_ne=false&isReviewed=${
          this.currentReviewStatus == "reviewed" ? true : false
        }&`;
      }

      if (this.currentRoad) {
        url += `road_in=${this.currentRoad.id}&`;
      }

      if (this.defectTypeFilter && this.defectTypeFilter.length) {
        this.defectTypeFilter.forEach((name) => {
          url += `defects.name_in=${encodeURIComponent(name)}&`;
        });

        url += `defects.isApproved=true&`;
      }

      if (type != "count") {
        url += `_sort=datetime:DESC&_limit=${this.pageLimit}&_start=${
          (this.currentPage - 1) * this.pageLimit
        }&`;
      }

      return url;
    },
    // async getTotalDefectCount() {
    //   const params = this.dashcamEndpoint()
    //     .replace("dashcamvideos?", "")
    //     .split("&")
    //     .filter((e) => e)
    //     .map((e) => e.split("="));

    //   const paramsObj = params.reduce(
    //     (acc, curr) => (
    //       curr[0].endsWith("_in")
    //         ? acc[curr[0]]?.length
    //           ? acc[curr[0]].push(curr[1])
    //           : (acc[curr[0]] = [curr[1]])
    //         : (acc[curr[0]] = curr[1]),
    //       acc
    //     ),
    //     {}
    //   );

    //   delete paramsObj["_sort"];
    //   delete paramsObj["_start"];
    //   paramsObj["_limit"] = -1;

    //   const queryArr = [];

    //   Object.keys(paramsObj).forEach((key) => {
    //     if (typeof paramsObj[key] == "object") {
    //       paramsObj[key].forEach((element) => {
    //         queryArr.push(`${key}=${element}`);
    //       });
    //     } else {
    //       queryArr.push(`${key}=${paramsObj[key]}`);
    //     }
    //   });

    //   await API.get(`dashcamvideos/count/defects?${queryArr.join("&")}`).then(
    //     (retVal) => {
    //       this.totalDefectCount = retVal.data;
    //     }
    //   );

    //   return;
    // },
    async getVideos(type) {
      // Not reset on "update": the 30s poll would otherwise clear uploads
      // counted while the uploader is still open, and the watcher that reacts
      // on close would never fire.
      if (type != "update") {
        this.newVideoCount = 0;

        this.isProcessing = true;
      }

      if (type != "update" && type != "changePage") {
        if (this.map) {
          this.map.remove();

          this.map = null;
        }

        this.currentVideo = null;
      }

      if (type != "changePage") {
        this.currentPage = 1;
        this.inputPage = 1;

        if (type != "changePage") {
          this.currentPage = 1;
          this.inputPage = 1;
        }
      }

      await this.getTotalVideoCount();

      // await this.getTotalDefectCount();

      return await API.get(this.dashcamEndpoint())
        .then((retVal) => {
          // The query treats a missing isProcessed as processed
          // (isProcessed_ne=false), so mirror that here - otherwise the
          // template's truthiness checks would render such a record as
          // "Processing..." forever.
          retVal.data.forEach((v) => {
            v.isProcessed = v.isProcessed !== false;
          });

          if (type == "update") {
            this.videos = this.videos.map((video, index) => {
              const _video = retVal.data.find((data) => data._id == video._id);

              if (_video) {
                video = _video;
              }

              video.index = (this.currentPage - 1) * this.pageLimit + index + 1;

              return video;
            });
          } else {
            this.videos = retVal.data.length > 0 ? retVal.data : [];

            this.videos = this.videos.map((v, index) => {
              v.index = (this.currentPage - 1) * this.pageLimit + index + 1;

              return v;
            });

            if (this.videos.length > 0) {
              this.goTo(this.videos[0]._id);
            }

            this.totalPage = Math.ceil(this.totalVideoCount / this.pageLimit);

            this.$nextTick(() => {
              this.scrollListToTop();

              this.isProcessing = false;
            });
          }

          if (this.updateVideoStatus) {
            clearInterval(this.updateVideoStatus);
          }

          this.updateVideoStatus = setInterval(() => {
            this.getVideos("update");
          }, 30000);
        })
        .catch((err) => {
          console.error(err);

          this.isProcessing = false;
        });
    },
    async getAIUser() {
      this.isProcessing = true;

      return await API.get("users?username=Infrasel AI")
        .then((retVal) => {
          this.aiUser = retVal.data.length > 0 ? retVal.data[0]._id : null;

          this.isProcessing = false;
        })
        .catch((err) => {
          console.error(err);

          this.isProcessing = false;
        });
    },
    async getAllDistricts() {
      this.isProcessing = true;

      return await API.get("districts?_sort=name")
        .then((retVal) => {
          this.allDistricts = retVal.data;

          this.isProcessing = false;
        })
        .catch((err) => {
          console.error(err);

          this.isProcessing = false;
        });
    },
    async getDistrictRoads(districtIds) {
      this.isProcessing = true;

      let url = "roadsOnly?_limit=-1";

      if (districtIds && districtIds.length > 0) {
        url += `&daerah_in=${districtIds.join("&daerah_in=")}`;
      }

      return await API.get(url)
        .then((retVal) => {
          this.isProcessing = false;

          return retVal.data;
        })
        .catch((err) => {
          console.error(err);

          this.isProcessing = false;

          return null;
        });
    },
    async getContractors() {
      this.isProcessing = true;

      this.contractors = [
        { _id: "612c5e628487e623af876e8a", name: "SELGEM" },
        {
          _id: "612e57ef8487e623af877561",
          name: "EDGENTA PROPEL BHD",
          districts: [
            "6042786166d30058184d1358",
            "6042786166d30058184d1357",
            "6042786166d30058184d135a",
            "6042786166d30058184d135b",
          ], // Kuala Langat, Hulu Langat, Klang, Sepang
        },
        {
          _id: "60159102fd624d513c3b81a4",
          name: "SRM SETIA SDN BHD",
          districts: [
            "6042786166d30058184d1355",
            "6042786166d30058184d1359",
            "6042786166d30058184d1353",
            "6042786166d30058184d1356",
            "6042786166d30058184d1354",
          ], // Gombak, Kuala Selangor, Petaling, Sabak Bernam, Hulu Selangor
        },
      ];

      this.isProcessing = false;

      // let url =
      //   "contractors?name_in=EDGENTA PROPEL BHD&name_in=SELGEM&name_in=SRM SETIA SDN BHD&_sort=name";

      // return API.get(url)
      //   .then((retVal) => {
      //     this.contractors = retVal.data;

      // this.isProcessing = false;

      //     return retVal.data;
      //   })
      //   .catch((err) => {
      //     console.error(err);

      //     this.isProcessing = false;
      //     return null;
      //   });
    },
  },
  async mounted() {
    this.newVideoCount = 0;

    let _user = localStorage.getItem("user");

    if (_user) {
      _user = JSON.parse(_user);

      if (_user.districts && _user.districts.length > 0) {
        this.userDistricts = _user.districts;

        const userRoads = await this.getDistrictRoads(
          _user.districts.map((d) => d._id)
        );

        this.userDistricts.forEach((district) => {
          district.roads = userRoads.filter(
            (road) => road.daerah._id == district._id
          );
        });
      }
      this.userDistricts = _user.districts ? _user.districts : [];
      this.userRole = _user.role.name;
    }

    // await this.getAIUser();
    await this.getAllDistricts();
    await this.getContractors();
    await this.getRoads();
    await this.getVideos();
    this.fetchDefectTypes();
  },
  beforeDestroy() {
    if (this.map) {
      this.map.remove();

      this.map = null;

      this.mapMarker = null;
    }

    if (this.updateVideoStatus) {
      clearInterval(this.updateVideoStatus);
    }
  },
};
</script>

<style lang="scss" scoped>
.dashcam-map {
  top: 1rem;
  right: 1rem;
  max-height: 45%;
  max-width: 45%;
  width: 400px;
  height: 240px;
}

::v-deep .case-container {
  overflow-x: visible !important;
  overflow-y: visible !important;
}

::v-deep .case-filter {
  overflow: visible !important;
}
</style>